import React from 'react';
import { Link } from 'react-router-dom';
import StructuredData from './StructuredData';

/**
 * Internal-link hub block used on city + brand pages to surface (and pass
 * PageRank into) the programmatic /{service}/{brand}/{city} leaf pages.
 *
 * Props:
 *   heading    : section H2
 *   subheading : optional lead line
 *   links      : [{ url, group, label, name }]  — group = service label,
 *                label = the varying dimension (brand on a city page, city on a
 *                brand page), name = full "Brand Service in City" (for schema).
 *
 * Renders pills grouped by service + an ItemList JSON-LD so Google reads it as
 * a structured collection rather than a link dump. Every URL is a real page
 * (the data is generated from the programmatic manifest).
 */
const ProgrammaticLinkHub = ({ heading, subheading, links }) => {
  if (!links || !links.length) return null;

  const groups = [];
  const groupIndex = {};
  links.forEach((l) => {
    if (!(l.group in groupIndex)) {
      groupIndex[l.group] = groups.length;
      groups.push({ name: l.group, items: [] });
    }
    groups[groupIndex[l.group]].items.push(l);
  });

  const itemList = {
    '@type': 'ItemList',
    itemListElement: links.map((l, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `https://www.ridenrepair.com${l.url}`,
      name: l.name,
    })),
  };

  return (
    <section className="rr-linkhub">
      <StructuredData data={itemList} />
      <div className="rr-container">
        <h2 className="rr-linkhub__heading">{heading}</h2>
        {subheading ? <p className="rr-linkhub__sub">{subheading}</p> : null}
        {groups.map((g, gi) => (
          <div key={gi} className="rr-linkhub__group">
            <h3 className="rr-linkhub__group-title">{g.name}</h3>
            <div className="rr-linkhub__pills">
              {g.items.map((l, i) => (
                <Link key={i} to={l.url} className="rr-linkhub__pill" title={l.name}>{l.label}</Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgrammaticLinkHub;
